import { Component, HostListener, Output, EventEmitter, OnInit } from '@angular/core';
import { CreateProjectService } from '../services/create-project.service';
import { AppMaterialModule } from '../app-modules/app-material.module';
import { UtilModule } from '../app-modules/util.module';

@Component({
  selector: 'app-summary',
  standalone: true,
  imports: [AppMaterialModule, UtilModule],
  templateUrl: './summary.component.html',
  styleUrl: './summary.component.css'
})
export class SummaryComponent implements OnInit {
  isSubmitted = false;
  scrHeight = '';
  bodyHeight = '';
  collectionData:any;

  @Output() navigateToCollection = new EventEmitter<void>();
  @Output() navigateToProject = new EventEmitter<void>();
  @Output() navigateToTeam = new EventEmitter<void>();
  @Output() navigateToEmail = new EventEmitter<void>();
  @Output() navigateToDocuments = new EventEmitter<void>();
  subcollectionData: any;
  projectData: any;
  emailData: any;
  departmentData: any;
  selectedFiles: any[] = [];

  constructor(private readonly createProjectService: CreateProjectService){}
  @HostListener('window:resize', ['$event'])
  getScreenSize(_event?: Event) {
    this.scrHeight = `${window.innerHeight - 270}px`;
    this.bodyHeight = `${window.innerHeight - 300}px`;
  }
  ngOnInit(){
    this.getScreenSize();
    this.collectionData=this.createProjectService.getSelectedCollection();
    this.subcollectionData=this.createProjectService.getSelectedSubCollection();
    this.projectData=this.createProjectService.getSelectedProject();
    this.emailData=this.createProjectService.getSelectedEmail();
    this.departmentData=this.createProjectService.getSelectedDepartment();
    this.selectedFiles=this.createProjectService.getSelectedFiles();
    console.info( this.departmentData);
    console.info( this.emailData);
    console.info( this.projectData);
  }

  editCollection() {
    this.navigateToCollection.emit();
  }

  editProject() {
    this.navigateToProject.emit();
  }

  editTeam() {
    this.navigateToTeam.emit();
  }

  editEmail() {
    this.navigateToEmail.emit();
  }

  editDepartment() {
    this.navigateToTeam.emit();
  }

  editDocuments() {
    this.navigateToDocuments.emit();
  }

  formatDate(date: Date): string {
    if (!date) {
      return '';
    }
    
    const dateObj = new Date(date);
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const month = months[dateObj.getMonth()];
    const day = dateObj.getDate();
    const year = dateObj.getFullYear();
    
    let hours = dateObj.getHours();
    const minutes = dateObj.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours || 12; // 0 should be 12
    const minutesStr = minutes < 10 ? '0' + minutes : minutes;
    
    return `${month} ${day}, ${year}, ${hours}:${minutesStr} ${ampm}`;
  }

  formatDueDate(date: any): string {
    if (!date) {
      return '';
    }
    
    const dateObj = new Date(date);
    const day = String(dateObj.getDate()).padStart(2, '0');
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const year = dateObj.getFullYear();
    
    return `${year}-${month}-${day}`;
  }

  stripHtml(html: string): string {
    if (!html) {
      return '';
    }
    
    // Convert <br>, <br/>, and <br /> tags to newlines
    let text = html.replaceAll(/<br\s*\/?>/gi, '\n');
    
    // Convert </p> and </div> tags to double newlines for paragraph separation
    text = text.replaceAll(/<\/(p|div)>/gi, '\n\n');
    
    // Remove all other HTML tags
    const tmp = document.createElement('DIV');
    tmp.innerHTML = text;
    text = tmp.textContent || tmp.innerText || '';
    
    // Clean up excessive newlines (more than 2 consecutive)
    text = text.replaceAll(/\n{3,}/g, '\n\n');
    
    // Trim whitespace from each line while preserving line breaks
    text = text.split('\n').map(line => line.trim()).join('\n');
    
    // Ensure proper spacing after greetings (Hi/Hello/Dear [name],)
    text = text.replaceAll(/(Hi|Hello|Dear)\s*([^,\n]*)(,?)(\s*\n)?/gi, (_match, greeting, name, comma, _newline) => {
      const formattedComma = comma || ',';
      return `${greeting}${name ? ' ' + name : ''}${formattedComma}\n\n`;
    });
    
    // Ensure proper spacing before closings with optional name after
    // This will match patterns like "Thanks," or "Thanks,\nJohn" and format them properly
    text = text.replaceAll(/\n*(Thanks|Thank you|Regards|Best regards|Sincerely|Best|Cheers)(\s*,?)(\s*\n)?/gi, '\n\n$1$2\n');
    
    // Clean up excessive newlines again after formatting
    text = text.replaceAll(/\n{3,}/g, '\n\n');
    
    return text.trim();
  }

  getTeamMembersByDepartment(deptId: string): any[] {
    if (!this.departmentData?.selectedMembers) {
      return [];
    }
    return this.departmentData.selectedMembers.filter((member: any) => String(member.tm_dept_id) === deptId);
  }

  formatBytes(bytes: number): string {
    if (!bytes) {
      return '0 B';
    }
    const sizes = ['B','KB','MB','GB','TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return `${Number.parseFloat((bytes / Math.pow(1024, i)).toFixed(2))} ${sizes[i]}`;
  }

  getFileIcon(file: any): string {
    if (!file) {
      return 'insert_drive_file';
    }
    const name = (file.name || '').toLowerCase();
    const type = (file.type || '').toLowerCase();

    if (type.includes('pdf') || name.endsWith('.pdf')) {
      return 'picture_as_pdf';
    }
    if (type.includes('spreadsheet') || type.includes('excel') || name.endsWith('.xls') || name.endsWith('.xlsx') || name.endsWith('.xlsm')) {
      return 'table_chart';
    }
    if (type.includes('word') || name.endsWith('.doc') || name.endsWith('.docx')) {
      return 'description';
    }
    if (type.startsWith('image/') || name.endsWith('.png') || name.endsWith('.jpg') || name.endsWith('.jpeg')) {
      return 'image';
    }
    return 'insert_drive_file';
  }

  submitReview() {
    if (this.isSubmitted) {
      console.info("Review submitted for compliance");
    }
  }
}
